import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { useTopBlockStyles } from "../../../Hooks/useTopBlockStyles";
import type { StyleValue } from "../../../StyleValue.types";
import { primaryBlockDefaultStyles } from "../../Homepage/constants";

export interface AboutUsBlock1Props
  extends Omit<ComponentPropsWithRef<"div">, "content"> {
  actions?: ReactNode;
  cards: ReactNode;
  content: ReactNode;
  footer: ReactNode;
  header: ReactNode;
  image: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const AboutUsBlock1 = forwardRef<HTMLDivElement, AboutUsBlock1Props>(
  (
    {
      header,
      content,
      actions,
      image,
      footer,
      cards,
      className,
      styles,
      ...rest
    },
    ref,
  ) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles: primaryBlockDefaultStyles,
      },
    );

    return (
      <BlockSection ref={ref} className={className} {...rest}>
        <BlockSection.Background style={backgroundStyles}>
          <BlockSection.Container>
            <BlockSection.Content
              style={{
                ...paddingStyles,
                ...marginStyles,
              }}
            >
              <div className="wb-grid md:wb-grid-cols-2 md:wb-gap-12 wb-gap-4">
                <div>{header}</div>
                <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-gap-4 md:wb-gap-8">
                  {content}
                  <BlockSection.NestedBlock>{actions}</BlockSection.NestedBlock>
                </BlockSection.NestedBlock>
              </div>
              <div>{image}</div>
              <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-gap-2 md:wb-gap-6 wb-max-w-3xl wb-mx-auto">
                {footer}
              </BlockSection.NestedBlock>
              <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-items-center wb-gap-4 md:wb-grid md:wb-grid-cols-2 md:wb-gap-[1.88rem] lg:wb-grid-cols-4">
                {cards}
              </BlockSection.NestedBlock>
            </BlockSection.Content>
          </BlockSection.Container>
        </BlockSection.Background>
      </BlockSection>
    );
  },
);

AboutUsBlock1.displayName = "AboutUsBlock1";
